/**
 * R5Section
 * -----------------------------------------------------------
 * Frosted-glass section block with title row + meta + actions.
 * Mirrors r2-section / t3-section layout in the mocks.
 *
 * Props:
 *   title:    string or node
 *   meta:     small right-aligned label (e.g. "Captain's Picks")
 *   actions:  inline-flex slot (right side, after meta)
 *   id:       anchor target
 *   className: extra classes
 */
import React from 'react';

export function R5Section({
  title,
  meta,
  actions,
  id,
  className = '',
  children,
  ...rest
}) {
  const cls = ['r5-section-block', className].filter(Boolean).join(' ');
  const showHead = title || meta || actions;

  return (
    <section className={cls} id={id} {...rest}>
      {showHead && (
        <div className="r5-section-block__head">
          {title && <h2 className="r5-section-block__title">{title}</h2>}
          {meta && <span className="r5-section-block__meta">{meta}</span>}
          {actions && <span className="r5-section-block__actions">{actions}</span>}
        </div>
      )}
      {children}
    </section>
  );
}

export default R5Section;
